import apiClient from "./axios"

// ============================
// 🔹 Company Pad API Services
// ============================

// Get all company pads (paginated or filtered)
export const getCompanyPads = async (params = {}) => {
  const { data } = await apiClient.get("/company-pads", { params })
  return data
}

// Get all company pads without pagination
export const getAllCompanyPads = async (params = {}) => {
  const { data } = await apiClient.get("/company-pads", {
    params: { ...params, all: true },
  })
  return data
}

// Get a specific company pad by ID
export const getCompanyPad = async id => {
  const { data } = await apiClient.get(`/company-pads/${id}`)
  return data
}

// Create a new company pad
export const createCompanyPad = async padData => {
  const { data } = await apiClient.post("/company-pads", padData)
  return data
}

// Update an existing company pad
export const editCompanyPad = async ({ id, ...padData }) => {
  const { data } = await apiClient.patch(`/company-pads/${id}`, padData)
  return data
}

// Soft delete a company pad
export const deleteCompanyPad = async id => {
  const resolvedId = typeof id === "object" ? id?.id : id
  const { data } = await apiClient.delete(`/company-pads/${resolvedId}`)
  return data
}

// Get trashed company pads
export const getTrashedCompanyPads = async (params = {}) => {
  const { data } = await apiClient.get("/company-pads/trashed", { params })
  return data
}

// Restore a trashed company pad
export const restoreCompanyPad = async id => {
  const { data } = await apiClient.post(`/company-pads/${id}/restore`)
  return data
}

// Permanently delete a company pad
export const forceDeleteCompanyPad = async id => {
  const { data } = await apiClient.delete(`/company-pads/${id}/force-delete`)
  return data
}
